import { Component, OnInit } from '@angular/core';
import { ClientService } from '../services/client.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Router } from '@angular/router';


@Component({
  selector: 'app-insert-client',
  templateUrl: './insert-client.component.html',
  styleUrls: ['./insert-client.component.css']
})
export class InsertClientComponent implements OnInit {
  name: string;
  eik: number;
  dds: number;
  address: string;
  city: string;
  mol: string;
  phone: string;
  email: string;
  discount: string;
  doc_address: string;
  contract: boolean;
  contact: string;
  //en
  name_en: string;
  address_en: string;
  city_en: string;
  mol_en: string;
  phone_en: string;
  email_en: string;
  doc_address_en: string;
  contact_en: string;
  //ru
  name_ru: string;
  address_ru: string;
  city_ru: string;
  mol_ru: string;
  phone_ru: string;
  email_ru: string;
  doc_address_ru: string;
  contact_ru: string;



  constructor(private clientService: ClientService, private route: ActivatedRoute,
    private location: Location,
    private router: Router) {
    const id = +this.route.snapshot.paramMap.get('id');
    if (id != 0) {
      this.editClient(id);
    } else {
      this.dds = 1;
      this.discount = '0';
    }
  }

  ngOnInit() {
  }

  submit(clientForm) {
    var formData = {
      bg: {
        name: clientForm.name,
        eik: clientForm.eik,
        discount: clientForm.discount,
        address: clientForm.address,
        city: clientForm.city,
        dds: clientForm.dds,
        mol: clientForm.mol,
        phone: clientForm.phone,
        contract: clientForm.contract,
        email: clientForm.email,
        contact: clientForm.contact,
        doc_address: clientForm.doc_address
      },
      en: {
        name: clientForm.name_en,
        eik: clientForm.eik,
        discount: clientForm.discount,
        address: clientForm.address_en,
        city: clientForm.city_en,
        dds: clientForm.dds,
        mol: clientForm.mol_en,
        phone: clientForm.phone_en,
        contract: clientForm.contract,
        email: clientForm.email_en,
        contact: clientForm.contact_en,
        doc_address: clientForm.doc_address_en
      },
      ru: {
        name: clientForm.name_ru,
        eik: clientForm.eik,
        discount: clientForm.discount,
        address: clientForm.address_ru,
        city: clientForm.city_ru,
        dds: clientForm.dds,
        mol: clientForm.mol_ru,
        phone: clientForm.phone_ru,
        contract: clientForm.contract,
        email: clientForm.email_ru,
        contact: clientForm.contact_ru,
        doc_address: clientForm.doc_address_ru
      }
    };

    console.log(formData);
    const id = +this.route.snapshot.paramMap.get('id');
    if (id == 0) {
      this.clientService.saveClient(formData).subscribe(data => {
        this.router.navigate(['/clients']);
      });
    } else {
      this.clientService.updateClient(formData, id).subscribe(data => {
        console.log(data);
        this.router.navigate(['/clients']);
      });
    }
  }

  contractFunc() {
    if (this.contract) {
      if ((!this.discount || this.discount == '0') || parseInt(this.discount) <= 5) {
        this.discount = '5';
      }
    } else {
      this.discount = '0';
    }
  }

  editClient(id) {
    this.clientService.editClient(id).subscribe(data => {
      console.log(data, data['ru']);
      this.name = data.bg.name,
        this.eik = data.bg.eik,
        this.discount = data.bg.discount,
        this.address = data.bg.address,
        this.city = data.bg.city,
        this.dds = data.bg.dds,
        this.mol = data.bg.mol,
        this.phone = data.bg.phone,
        this.contract = data.bg.contract,
        this.email = data.bg.email,
        this.contact = data.bg.contact,
        this.doc_address = data.bg.doc_address
      //en
      if (data['en']) {
        this.name_en = data.en.name,
          this.address_en = data.en.address,
          this.city_en = data.en.city,
          this.mol_en = data.en.mol,
          this.phone_en = data.en.phone,
          this.email_en = data.en.email,
          this.contact_en = data.en.contact,
          this.doc_address_en = data.en.doc_address
      }
      //ru
      if (data['ru']) {
        this.name_ru = data.ru.name,
          this.address_ru = data.ru.address,
          this.city_ru = data.ru.city,
          this.mol_ru = data.ru.mol,
          this.phone_ru = data.ru.phone,
          this.email_ru = data.ru.email,
          this.contact_ru = data.ru.contact,
          this.doc_address_ru = data.ru.doc_address
      }



    });
  }

}


